module.exports = __webpack_public_path__ + "static/img/SEforALL_Delivery-Partner_Digital.a2370c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/outreach/SEforALL_Delivery-Partner_Digital.png
// module id = Acvv
// module chunks = 0